import React from 'react';
import PolicyHeader from './PolicyHeader';
import Footer from './Footer';
import './PrivacyPolicy.css';

export default function PrivacyPolicy({ setIsLoginOpen, setIsSignupOpen, openEnroll }) {
  return (
    <div className="policy-container">
      <PolicyHeader />
      <main className="policy-content">
        <h1>Privacy Policy</h1>

        <p>This Privacy Policy (the “Policy”) governs the manner in which the Platform collects, uses, maintains and discloses information of its users...</p>

        <h3>PERSONAL INFORMATION</h3>
        <p>“Personal Information” shall mean the information which identifies a Learner i.e., first and last name...</p>

        <h3>INFORMATION WE COLLECT</h3>
        <ul>
          <li>We do not ask You for Personal Information unless we truly need it.</li>
          <li>We do not share Your Personal Information with anyone except to comply with applicable laws...</li>
          <li>We do not store Personal Information on our servers unless required...</li>
        </ul>

        <h3>HOW WE USE and SHARE THE INFORMATION COLLECTED</h3>
        <ol>
          <li>To provide access to our Platform and/or services offered therein.</li>
          <li>To improve our Platform and maintain safety.</li>
          <li>To communicate with You or market our services/products.</li>
        </ol>

        <h3>YOUR CHOICES</h3>
        <ul>
          <li>Limit the information You provide</li>
          <li>Limit the communications You receive from us</li>
          <li>Reject Cookies and other similar technologies</li>
        </ul>

        <h3>YOUR RIGHTS</h3>
        <ol type="A">
          <li>Right to Confirmation and Access</li>
          <li>Right to Correction</li>
          <li>Right to be Forgotten</li>
          <li>Right to Erasure</li>
        </ol>

        <h3>PROTECTION OF YOUR INFORMATION</h3>
        <p>We take all measures reasonably necessary to protect against unauthorized access...</p>

        <h3>THIRD PARTY WEBSITES</h3>
        <p>You may find links to other websites...</p>

        <h3>CROSS-BORDER DATA TRANSFER</h3>
        <p>Your information is stored and processed in India and possibly other countries...</p>

        <h3>DURATION FOR WHICH YOUR INFORMATION IS STORED</h3>
        <p>We will retain your data as long as needed...</p>

        <h3>MODIFICATION TO PRIVACY POLICY</h3>
        <p>We may update our Policy from time to time...</p>

        <h3>GRIEVANCES</h3>
        <p>For any privacy-related questions, contact us at: <a href="mailto:team@robokalam.com">team@robokalam.com</a></p>

        <h3>COUNTRY SPECIFIC ADDITIONAL RIGHTS</h3>

        <h4>I. Indian Residents</h4>
        <ol type="i">
          <li>Right to Confirmation and Access</li>
          <li>Right to Correction</li>
          <li>Right to Data Portability</li>
          <li>Right to be Forgotten</li>
          <li>Right to Erasure</li>
        </ol>

        <h4>II. UK / EU / EEA Residents</h4>
        <ol type="i">
          <li>Right to access your Personal Information</li>
          <li>Right to Rectification</li>
          <li>Right to Erasure</li>
          <li>Right to object to Processing</li>
          <li>Right to restrict Processing</li>
          <li>Right to Data Portability</li>
          <li>Right to not be subject to automated decision-making</li>
        </ol>

        <h4>III. California Residents (CCPA)</h4>
        <ol type="a">
          <li>The right to access the Personal Information we hold</li>
          <li>The right to know what information is collected</li>
          <li>The right to opt in/out of marketing</li>
          <li>The right to request deletion</li>
          <li>The right to equal services without discrimination</li>
        </ol>

      </main>
      <Footer openEnroll={openEnroll}/>
    </div>
  );
}
